export default "__VITE_ASSET__f97f7384__"